import { render, staticRenderFns } from "./loginAndOtherComponent.vue?vue&type=template&id=5e8f3d4c&scoped=true"
import script from "./loginAndOtherComponent.vue?vue&type=script&lang=js"
export * from "./loginAndOtherComponent.vue?vue&type=script&lang=js"
import style0 from "./loginAndOtherComponent.vue?vue&type=style&index=0&id=5e8f3d4c&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8f3d4c",
  null
  
)

export default component.exports